import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/banner/2.jpg');

const filters = [
    { label: "Construction", filter: ".cat-1" },
    { label: "Renovation", filter: ".cat-2" },
    { label: "Outdoor", filter: ".cat-3" },
    { label: "Interiors", filter: ".cat-4" },
    { label: "Completed", filter: ".cat-5" },
    
];

const projects = [
    {
        thumb: require('./../../images/projects/portrait/pic1.jpg'),
        image: require('./../../images/projects/portrait/pic4.jpg'),
        title: 'Victoria Apartment',
        description: `46 multifamily rental units with on-site leasing office`,
        filter: 'cat-5'
    },
    {
        thumb: require('./../../images/projects/portrait/pic2.jpg'),
        image: require('./../../images/projects/portrait/pic9.jpg'),
        title: 'Casa Apartment',
        description: `29 multifamily rental units`,
        filter: 'cat-5'
    },
    {
        thumb: require('./../../images/projects/portrait/pic3.jpg'),
        image: require('./../../images/projects/portrait/pic6.jpg'),
        title: 'Apex Townhomes',
        description: `37 Unit Apartment Building | $11,399,999 ($308,108/Unit) | Manchester, CT 06042`,
        filter: 'cat-5'
    },
    {
        thumb: require('./../../images/projects/portrait/pic4.jpg'),
        image: require('./../../images/projects/portrait/pic5.jpg'),
        title: 'North BB Creek Townhomes',
        description: `62 New Townhomes in Taylor, TX. Samsung is setting up $45B chip manufacturing plant in Taylor, TX. Groundbreaking 6/2024. Built to Sell product.`,
        filter: 'cat-5'
    },
    {
        thumb: require('./../../images/projects/portrait/pic5.jpg'),
        image: require('./../../images/projects/portrait/pic7.jpg'),
        title: 'Bidwell Commons',
        description: `Modern Townhome Living in the Heart of Manchester, CT 26 New Townhomes in Bidwell St in Manchester, CT. Groundbreaking soon. BTR product.`,
        filter: 'cat-1'
    },
    {
        thumb: require('./../../images/projects/portrait/pic6.jpg'),
        image: require('./../../images/projects/portrait/pic8.jpg'),
        title: 'Townhomes @ Manchester, CT',
        description: `37 Townhomes Manchester CT is an active town with lots of restaurants, malls, offices, industries, and other recreational amenities Oakland Street is a high traffic road with lots of commercial and apartment complexes.`,
        filter: 'cat-1'
    },
    {
        thumb: require('./../../images/projects/portrait/pic7.jpg'),
        image: require('./../../images/projects/portrait/pic10.jpg'),
        title: 'AW Grimes',
        description: `Mixed development of 5.6 acres in AW Grimes near Teravista, Round Rock, TX.`,
        filter: 'cat-1'
    },
    {
        thumb: require('./../../images/projects/portrait/pic8.jpg'),
        image: require('./../../images/projects/portrait/pic1.jpg'),
        title: 'Apartments in Chennai',
        description: `Built and sold several apartments in Chennai, India`,
        filter: 'cat-3'
    },
    {
        thumb: require('./../../images/projects/portrait/pic9.jpg'),
        image: require('./../../images/projects/portrait/pic5.jpg'),
        title: '75 Apartment units in Houston',
        description: `75 Apartment units in Houston, TX – 75 units in East Houston were renovated with new cabinets, appliances and flooring. Purchased in 2020. Listed for Sale.`,
        filter: 'cat-5'
    },
    {
        thumb: require('./../../images/projects/portrait/pic9.jpg'),
        image: require('./../../images/projects/portrait/pic5.jpg'),
        title: 'Southside Meadows',
        description: `Southside Meadows, Elgin, TX Land development Project.`,
        filter: 'cat-1'
    },
    {
        thumb: require('./../../images/projects/portrait/pic9.jpg'),
        image: require('./../../images/projects/portrait/pic5.jpg'),
        title: 'Northside Meadows',
        description: `Northside Meadows – 50 acres of Land development project in Elgin, TX. Very close to Samsung’s new plant in Taylor, TX. 260 Single family lots will be sold to a National builder. Contract with the builder is in place. Completion Date 6/2025`,
        filter: 'cat-1'
    },
    {
        thumb: require('./../../images/projects/portrait/pic9.jpg'),
        image: require('./../../images/projects/portrait/pic5.jpg'),
        title: 'Mixed development of 28.5 acres in Taylor',
        description: `A Premier Mixed development of 28.5 acres in Taylor, TX very close to Samsung Taylor plant.`,
        filter: 'cat-1'
    },
    {
        thumb: require('./../../images/projects/portrait/pic9.jpg'),
        image: require('./../../images/projects/portrait/pic5.jpg'),
        title: 'Single Family home in South Windsor',
        description: `Single Family home in South Windsor, CT –Ground up construction of 3000 sq ft of Single-Family home in Deming Estates. Excellent reviews by Buyer. Sold in 12/2021.`,
        filter: 'cat-5'
    },
    {
        thumb: require('./../../images/projects/portrait/pic9.jpg'),
        image: require('./../../images/projects/portrait/pic5.jpg'),
        title: '28 Apartment units in New Britain, CT',
        description: `28 apartment units were refurbished and renovated with new flooring, cabinets and appliances. Purchased in 2016 and sold in 2021.`,
        filter: 'cat-5'
    }
]

class ProjectGrid extends React.Component {
    
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };
    
    render() {
        return (
            <>
                <Header />
                <div className="page-content">
                <Banner title="Always dedicated and devoted" pagename="Project Grid" bgimage={bnrimg}/>
                    
                    {/* SECTION CONTENT START */}
                    <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                            {/* PAGINATION START */}
                            <div className="filter-wrap p-b30 text-center">
                                <ul className="filter-navigation inline-navigation masonry-filter link-style  text-uppercase">
                                    <li className="active"><NavLink to={"#"} data-filter="*" data-hover="All">All</NavLink></li>
                                    {filters.map((item, index) => (
                                    <li key={index}><NavLink to={"#"} data-filter={item.filter} data-hover={item.label}>{item.label}</NavLink></li>
                                    ))} 
                                </ul>
                            </div>
                            {/* PAGINATION END */}
                            {/* GALLERY CONTENT START */}
                            <div className="portfolio-wrap mfp-gallery work-grid row clearfix">
                                {projects.map((item, index) => (
                                    <div key={index} className={`${item.filter} masonry-item col-md-4 col-sm-6 m-b30`}>
                                        <div className="image-effect-two hover-shadow">
                                            <img src={item.thumb} alt="" />
                                            <div className="figcaption">
                                                <h4 className="mt-tilte">{item.title}</h4>
                                                <p>{item.description}</p>
                                                <NavLink to="/project-detail" className="read-more site-button btn-effect">Read More</NavLink>
                                                <a className="mfp-link" href={item.image}>
                                                    <i className="fa fa-arrows-alt" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                
                            </div>
                            {/* GALLERY CONTENT END */}
                            <div className="m-t50 text-center">
                                {/* <NavLink to={"/"} className="site-button btn-effect">Load More</NavLink> */}
                            </div>
                        </div>
                    </div>
                    {/* SECTION CONTENT END  */}
                </div>

                <Footer />
            </>
        );
    };
};

export default ProjectGrid;